export const PARTNER_SETTINGS_COPY = "realEstate.casaMapa.admin.partnerSettings";

export function formatPartnerSettingsWhen(value) {
  if (!value) return null;
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return null;
  return date.toLocaleString();
}

export function partnerSettingsStatusBadgeClass(status) {
  const normalized = String(status || "").toLowerCase();
  if (normalized === "connected" || normalized === "approved") {
    return "cm-partner-settings__badge cm-partner-settings__badge--ok";
  }
  if (normalized === "submitted" || normalized === "in_review" || normalized === "pending") {
    return "cm-partner-settings__badge cm-partner-settings__badge--warn";
  }
  return "cm-partner-settings__badge";
}
